import React from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import Text from '../Text/Text'
import { SCREEN_SIZE } from '../../lib/Media'
import Halal from '../icons/svg/halal.svg'
import Hypoallergenic from '../icons/svg/hypoallergenic.svg'
import LactoseFree from '../icons/svg/lactose_free.svg'
import TransfatFree from '../icons/svg/transfat_free.svg'
import Vegetarian from '../icons/svg/vegetarian.svg'
import Organic from '../icons/svg/organic.svg'
import GlutenFree from '../icons/svg/gluten_free.svg'
import { decodeEntities } from '../../lib/stringHelperFunctions'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import SvgInfo from '@ntuctech/devex-tangram/Icon/SvgInfo'

const DietaryContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  > div {
    margin-right: 0.75rem;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
  }
`

const DieatryElements = styled.div`
  display: inline-flex;
  align-items: center;
  padding-bottom: 4px;
  > span {
    margin-left: 0.375rem;
  }
`

const StyledIcon = styled.img`
  height: 1.5rem;
  width: 1.5rem;
`

const InfoIconContainer = styled.button`
  margin: 0;
  margin-left: 0.25rem;
  display: flex;
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
`

const DietaryIconMapper = {
  vegetarian: Vegetarian,
  hypoallergenic: Hypoallergenic,
  lactosefree: LactoseFree,
  glutenfree: GlutenFree,
  organic: Organic,
  halal: Halal,
  transfatfree: TransfatFree,
}

export const DietaryListAttribute = ({
  metadata,
  onHealthierChoiceInfoPress,
}) => {
  const { isEnabled: healthierChoiceInfoEnabled } = getConfigFor(
    SPLIT_FEATURES.HEALTHIER_CHOICE_INFO_ENABLED
  )

  return (
    <DietaryContainer>
      {metadata.value.map(key => {
        const caseInsensitiveKey = (key || '')
          .toLowerCase()
          .replace(/[^a-z]+/g, '')
        const iconSrc = DietaryIconMapper[caseInsensitiveKey]
        const text = key.replace(/<\s*\/?u\s*>/g, '')
        return (
          <DieatryElements key={key}>
            {iconSrc && <StyledIcon src={iconSrc} alt="Dietary information" />}
            <Text
              size="medium"
              color={defaultTheme.ColorBaseMineShaft700}
              weight="bold"
            >
              {decodeEntities(text)}
            </Text>
            {healthierChoiceInfoEnabled &&
              caseInsensitiveKey === 'healthierchoice' && (
                <InfoIconContainer
                  data-testid="healthier-choice-info"
                  onClick={() => {
                    onHealthierChoiceInfoPress()
                  }}
                >
                  <SvgInfo size="s" color="#666666" />
                </InfoIconContainer>
              )}
          </DieatryElements>
        )
      })}
    </DietaryContainer>
  )
}
